export default `
  query listGitHubRepoBranches($login: String!, $owner: String!, $repo: String!, $pageUrl: String) {
    listGitHubRepoBranches(login: $login, owner: $owner, repo: $repo, pageUrl: $pageUrl) {
      success
      errorText
      resData {
        branches {
          name
          protected
          commit {
            sha
            url
          }
        }
        nextPageUrl
      }
    }
  }
`
